export const EDITAR_ACTION = 'EDITAR';
export const REGISTRAR_ACTION = 'REGISTRAR';
export const DETALLE_PDF_ACTION = 'DETALLE_PDF';
export const UNDEFINED_ACTION = 'UNDEFINED'
export const AUDITORIA_ACTION = 'AUDITORIA'
